import { Dialog, InlineDialog } from 'components/dialogs/Dialog'
import { GoogleStorageImage } from 'components/GoogleStorageImage'
import { useDialogs } from 'hooks/dialogs'
import { useTranslationTyped } from 'i18n/i18n'

export const ImagePreviewDialog = ({
  src,
  inline = false,
  onDismiss,
  alt,
}: {
  src: string
  inline?: boolean
  onDismiss?: () => void
  requiresAuthHeaders?: boolean
  skipCache?: boolean
  alt: string
}) => {
  const { tt } = useTranslationTyped()
  const DialogToUse = inline ? InlineDialog : Dialog
  const { popDialog } = useDialogs()
  return (
    <DialogToUse
      size="lg"
      onDismiss={onDismiss}
      unstyledWrapper={true}
      className="flex h-[85vh] w-[85vw] items-center justify-center"
      innerClassName="flex max-h-full max-w-full h-full w-full shrink items-center justify-center object-scale-down"
      dismissOnEscapeKey={!inline}
      aria-labelledby={undefined}
      aria-label={tt.common.preview()}
    >
      <GoogleStorageImage
        key={src}
        className="max-h-full max-w-full object-scale-down"
        namespace="preview-dialog"
        alt={alt}
        src={src}
        onClick={(e) => {
          e.stopPropagation()
          if (!inline) popDialog()
          onDismiss?.()
        }}
      />
    </DialogToUse>
  )
}
